import React from 'react';
import { Flag, SignpostBig, Car, Magnet, CreditCard, Gift, ExternalLink } from 'lucide-react';
import { Button } from './ui/Button';
export function ExpandedServices() {
  const services = [{
    icon: <Flag className="w-6 h-6" data-id="element-22" />,
    title: 'Banners',
    description: 'Indoor and outdoor banners for events, promotions, and displays.'
  }, {
    icon: <SignpostBig className="w-6 h-6" data-id="element-23" />,
    title: 'Yard Signs',
    description: 'Custom yard signs for real estate, events, and campaigns.'
  }, {
    icon: <Car className="w-6 h-6" data-id="element-24" />,
    title: 'Vehicle Graphics & Decals',
    description: 'Professional vehicle wraps, decals, and window graphics.'
  }, {
    icon: <Magnet className="w-6 h-6" data-id="element-25" />,
    title: 'Vehicle Magnets',
    description: 'Removable magnetic signs for cars, trucks, and vans.'
  }, {
    icon: <CreditCard className="w-6 h-6" data-id="element-26" />,
    title: 'Business Cards & Labels',
    description: 'Professional business cards and custom product labels.'
  }, {
    icon: <Gift className="w-6 h-6" data-id="element-27" />,
    title: 'Promotional Products',
    description: 'Wide selection of branded promotional items and giveaways.',
    external: true
  }];
  return <section className="py-24 bg-white" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="text-center mb-16" data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-31">
            Additional Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-32">
            Beyond apparel, we offer a complete range of printing and
            promotional solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-33">
          {services.map((service, index) => <div key={index} className="group bg-white p-6 rounded-lg border border-gray-200 hover:border-wh-pink hover:shadow-md transition-all duration-300 cursor-pointer" data-id="element-34">
              <div className="flex items-start gap-4" data-id="element-35">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-gray-50 text-gray-600 group-hover:bg-pink-50 group-hover:text-wh-pink flex items-center justify-center transition-colors" data-id="element-36">
                  {service.icon}
                </div>
                <div className="flex-1" data-id="element-37">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-38">
                    {service.title}
                    {service.external && <ExternalLink className="w-4 h-4 text-gray-400" data-id="element-39" />}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-40">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-41">
          <Button variant="outline" size="lg" data-id="element-42">
            View All Services
          </Button>
        </div>
      </div>
    </section>;
}